import { connect } from 'react-redux'
import ModalActions from '../../../../../Redux/ModalRedux'
import OfflineDevicesByModelModal from './offline-devices-by-model-modal'
import OfflineDevicesByModelModalSelector from './offline-devices-by-model-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  translate('CardsModals'),
  connect(
    OfflineDevicesByModelModalSelector,
    mapDispatchToProps
  )
)(OfflineDevicesByModelModal)
